import { cn } from "@/utils";

export const RoadmapPC = ({ className }: { className?: string }) => (
  <div className={cn("roadmap", className)} style={{ animationDelay: "0.2s" }}>
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1440 719.2"
      className="origin-center"
    >
      <title>SVG Roadmap</title>

      <defs>
        <clipPath id="clippath">
          <rect className="cls-15" x={188.5} y={300.1} width={30} height={30} />
        </clipPath>
        <linearGradient
          id="linear-gradient"
          x1={214.7}
          y1={2257.6}
          x2={204}
          y2={2256.2}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1={208.8}
          y1={2249.4}
          x2={198.5}
          y2={2247.8}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1={210.8}
          y1={2240.2}
          x2={196.6}
          y2={2236.9}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1={206.4}
          y1={2265.2}
          x2={200.4}
          y2={2261.6}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-5"
          x1={219.1}
          y1={2247.1}
          x2={207.6}
          y2={2245.6}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1={199.8}
          y1={2246.9}
          x2={188.2}
          y2={2245.4}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1={215.7}
          y1={2238.2}
          x2={209.8}
          y2={2237.1}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-8"
          x1={218.6}
          y1={2254.3}
          x2={215.5}
          y2={2254.1}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-9"
          x1={197.4}
          y1={2238.2}
          x2={191.5}
          y2={2237.1}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-10"
          x1={203.3}
          y1={2257.6}
          x2={192.6}
          y2={2256.3}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-11"
          x1={191.5}
          y1={2254.2}
          x2={188.5}
          y2={2254}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <clipPath id="clippath-1">
          <rect className="cls-15" x={468.3} y={301.1} width={30} height={30} />
        </clipPath>
        <linearGradient
          id="linear-gradient-12"
          x1={485.1}
          y1={2261.5}
          x2={478}
          y2={2259.7}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-13"
          x1={498.8}
          y1={2245.1}
          x2={489.9}
          y2={2244.3}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-14"
          x1={482.1}
          y1={2259.9}
          x2={469.4}
          y2={2256.6}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-15"
          x1={498.9}
          y1={2254.3}
          x2={487.3}
          y2={2252}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-16"
          x1={489.2}
          y1={2244.5}
          x2={471.8}
          y2={2242.6}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-17"
          x1={485.9}
          y1={2249.5}
          x2={467.9}
          y2={2246.9}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-18"
          x1={493.4}
          y1={2261.1}
          x2={484}
          y2={2259}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-19"
          x1={493.2}
          y1={2242.6}
          x2={482.5}
          y2={2241.7}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <clipPath id="clippath-2">
          <rect className="cls-15" x={797} y={301.4} width={30} height={30} />
        </clipPath>
        <linearGradient
          id="linear-gradient-20"
          x1={828.9}
          y1={2250.1}
          x2={796.4}
          y2={2245.2}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <clipPath id="clippath-3">
          <rect className="cls-15" x={864.1} y={301} width={30} height={30} />
        </clipPath>
        <linearGradient
          id="linear-gradient-21"
          x1={872.8}
          y1={2258.3}
          x2={870.5}
          y2={2258}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-22"
          x1={872.8}
          y1={2261.5}
          x2={870.5}
          y2={2261.2}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-23"
          x1={872.9}
          y1={2252.8}
          x2={870.5}
          y2={2252.7}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-24"
          x1={881.2}
          y1={2245.2}
          x2={878.1}
          y2={2245.2}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-25"
          x1={887.3}
          y1={2245.2}
          x2={884.2}
          y2={2245.2}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-26"
          x1={893.4}
          y1={2245.2}
          x2={890.3}
          y2={2245.2}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-27"
          x1={892.4}
          y1={2260.4}
          x2={886.3}
          y2={2258.4}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-28"
          x1={885.4}
          y1={2260.4}
          x2={879.3}
          y2={2258.4}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-29"
          x1={871.1}
          y1={2236.9}
          x2={865}
          y2={2236}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-30"
          x1={875.4}
          y1={2243.7}
          x2={868.2}
          y2={2243.4}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <clipPath id="clippath-4">
          <rect className="cls-15" x={1056.2} y={301.8} width={30} height={30} />
        </clipPath>
        <linearGradient
          id="linear-gradient-31"
          x1={1085.2}
          y1={2236.1}
          x2={1078.7}
          y2={2233.8}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-32"
          x1={1085.4}
          y1={2238.6}
          x2={1078.7}
          y2={2236.6}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-33"
          x1={1085.9}
          y1={2255.7}
          x2={1076.4}
          y2={2254.8}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-34"
          x1={1064.1}
          y1={2236.7}
          x2={1057.9}
          y2={2235.9}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-35"
          x1={1076}
          y1={2238.7}
          x2={1064.9}
          y2={2236.9}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-36"
          x1={1079.2}
          y1={2245.9}
          x2={1073}
          y2={2245.1}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-37"
          x1={1065.7}
          y1={2245}
          x2={1061.3}
          y2={2244}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-38"
          x1={1064.8}
          y1={2248.5}
          x2={1061.3}
          y2={2247.9}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-39"
          x1={1065.6}
          y1={2252.9}
          x2={1061.2}
          y2={2252.1}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-40"
          x1={1061.5}
          y1={2245}
          x2={1057.1}
          y2={2244}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-41"
          x1={1061.4}
          y1={2252.8}
          x2={1057}
          y2={2252.1}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-42"
          x1={1060.6}
          y1={2248.5}
          x2={1057}
          y2={2247.9}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-43"
          x1={1069.1}
          y1={2245.1}
          x2={1065.5}
          y2={2244.7}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-44"
          x1={1069}
          y1={2252.8}
          x2={1065.4}
          y2={2252.3}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-45"
          x1={1076}
          y1={2255.1}
          x2={1057.6}
          y2={2252}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-46"
          x1={1069}
          y1={2249.1}
          x2={1065.5}
          y2={2248.7}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <clipPath id="clippath-5">
          <rect className="cls-15" x={1190} y={301.8} width={30} height={30} />
        </clipPath>
        <linearGradient
          id="linear-gradient-47"
          x1={1220.5}
          y1={2252.7}
          x2={1190.2}
          y2={2243.2}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-48"
          x1={1132}
          y1={2240.3}
          x2={1122.4}
          y2={2238.9}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-49"
          x1={1149.4}
          y1={2257.5}
          x2={1139.7}
          y2={2256}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-50"
          x1={1149.6}
          y1={2250.3}
          x2={1122.8}
          y2={2246.3}
          gradientTransform="translate(0 2564) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ffe500" />
          <stop offset={1} stopColor="#ffe500" />
        </linearGradient>
      </defs>
      <rect className="cls-8" y={-142.8} width={1440} height={858.8} />
      <g className="cls-66">
        <rect className="cls-60" y={-63.1} width={1440} height={605} />
        <rect className="cls-60" y={-142.8} width={1440} height={80} />
        <rect className="cls-60" y={-63.1} width={1440} height={605} />
        <rect className="cls-60" y={-142.8} width={1440} height={80} />
        <rect className="cls-60" y={621.3} width={1440} height={605} />
        <rect className="cls-60" y={1226.3} width={1440} height={80} />
        <rect className="cls-60" y={621.3} width={1440} height={605} />
        <g>
          <rect className="cls-60" y={1306} width={1440} height={605} />
          <rect className="cls-60" y={1990.4} width={1440} height={605} />
          <rect className="cls-60" y={1910.7} width={1440} height={80} />
          <rect className="cls-60" y={2595.1} width={1440} height={80} />
          <rect className="cls-60" y={541.6} width={1440} height={80} />
          <rect className="cls-60" y={541.6} width={1440} height={80} />
        </g>
      </g>
      <g id="Road_Map" data-name="Road Map">
        <g>
          <g>
            <rect className="cls-15" x={-35} y={-143.6} width={559} height={615} />
            <rect className="cls-15" x={876} y={202.4} width={559} height={384} />
          </g>
          <path
            className="cls-2"
            d="M1427.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1411.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1395.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1379.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1363.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1347.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1331.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1315.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1299.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1283.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1267.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1251.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1235.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1219.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1203.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1187.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1171.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1155.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1139.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1123.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1107.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1091.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1075.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1059.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1043.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1027.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM1011.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM995.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM979.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM963.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM947.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM931.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM915.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM899.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM883.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM867.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM851.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM835.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM819.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM803.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM787.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM771.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM755.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM739.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM723.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM707.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM691.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM675.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM659.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM643.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM627.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM611.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM595.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM579.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM563.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM547.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM531.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM515.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM499.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM483.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM467.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM451.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM435.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM419.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM403.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM387.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM371.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM355.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM339.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM323.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM307.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM291.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM275.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM259.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM243.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM227.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM211.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM195.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM179.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM163.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM147.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM131.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM115.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM99.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM83.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM67.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM51.2,319h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM35.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM19.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3ZM3.2,319h-1c-1.6,0-3-1.3-3-3s1.4-3,3-3h1c1.6,0,3,1.3,3,3s-1.4,3-3,3Z"
          />
          <g>
            <path className="cls-2" d="M212.7,134.7c0,5-4,9.2-9.2,9.2s-9.2-4-9.2-9.2,4-9.2,9.2-9.2,9.2,4,9.2,9.2Z" />
            <path
              className="cls-2"
              d="M203.5,288.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,272.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,256.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,240.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,224.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,208.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,192.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,176.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM203.5,160.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3Z"
            />
            <circle className="cls-38" cx={203.9} cy={314.1} r={32.6} />
            <g className="cls-63">
              <g>
                <path className="cls-7" d="M204.2,303.3v6l4.9,3.6,4.9-2.8v-5.6c-1.3-1.3-2.9-2.4-4.6-3.1l-5.2,2h0Z" />
                <path className="cls-31" d="M203.5,310.7l-4.8,3.5,1.8,5.6h5.9l1.8-5.6-4.8-3.5h.1Z" />
                <path className="cls-35" d="M207.4,329.5l2.8-4.5-3.6-3.8h-6.3l-3.6,3.8,2.8,4.5c2.6.7,5.4.7,8,0h0Z" />
                <path className="cls-53" d="M199.8,300.5l3.7,1.4,3.7-1.4c-1.2-.3-2.4-.5-3.7-.5s-2.5.2-3.7.5Z" />
                <path
                  className="cls-14"
                  d="M214.7,311.5l-4.9,2.8-1.9,5.9,3.6,3.8,5.3-2c.2-.3.3-.7.5-1.1.7-1.6,1.1-3.3,1.2-5l-3.8-4.5h0Z"
                />
                <path
                  className="cls-10"
                  d="M199.1,320.3l-1.9-5.9-4.9-2.8-3.8,4.5c0,1.6.5,3.2,1.1,4.7l.6,1.2,5.4,2.1,3.5-3.8h0Z"
                />
                <path className="cls-33" d="M215.4,324.2l-3.6,1.4-1.9,3c2.2-1,4.1-2.5,5.5-4.4Z" />
                <path className="cls-42" d="M215.6,306.3v3.8l2.7,3.2c-.2-1.3-.5-2.7-1-3.9-.5-1.1-1-2.2-1.7-3.1Z" />
                <path className="cls-36" d="M197.1,328.6l-1.9-3-3.6-1.4c1.4,1.9,3.3,3.4,5.5,4.4Z" />
                <path className="cls-52" d="M197.7,312.9l4.9-3.6v-6l-5.2-2c-1.7.8-3.3,1.8-4.6,3.1v5.6l4.9,2.8h0Z" />
                <path className="cls-13" d="M188.6,313.4l2.7-3.2v-3.8c-.6.9-1.2,1.9-1.6,2.9-.6,1.3-.9,2.8-1.1,4.2h0Z" />
              </g>
            </g>
          </g>
          <g>
            <g className="cls-56">
              <g className="cls-56">
                <text className="cls-55" transform="translate(116.4 106)">
                  <tspan x={0} y={0}>
                    {"Launch Phase"}
                  </tspan>
                </text>
              </g>
            </g>
            <g className="cls-56">
              <g className="cls-56">
                <text className="cls-55" transform="translate(68.5 163.6)">
                  <tspan x={0} y={0}>
                    {"2024 Q4"}
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <circle className="cls-38" cx={483.9} cy={314.6} r={32.6} transform="translate(22.7 661.6) rotate(-70)" />
          <g className="cls-56">
            <g className="cls-56">
              <text className="cls-55" transform="translate(304.1 551.8)">
                <tspan x={0} y={0}>
                  {"Sports and UI/ UX expansion"}
                </tspan>
              </text>
            </g>
          </g>
          <g className="cls-56">
            <g className="cls-56">
              <text className="cls-55" transform="translate(362.1 496.4)">
                <tspan x={0} y={0}>
                  {"2025 Q1"}
                </tspan>
              </text>
            </g>
          </g>
          <g>
            <circle className="cls-38" cx={812.3} cy={316} r={32.6} transform="translate(14.4 666.9) rotate(-45)" />
            <circle className="cls-38" cx={879.2} cy={316} r={32.6} transform="translate(34 714.3) rotate(-45)" />
            <path
              className="cls-2"
              d="M844.2,268.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,252.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,236.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,220.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,204.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,188.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,172.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,156.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3ZM844.2,140.4c-1.7,0-3-1.4-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.6-1.4,3-3,3Z"
            />
            <path
              className="cls-2"
              d="M877.2,282.4h-1c-1.7,0-3-1.4-3-3s1.3-3,3-3h1c1.6,0,3,1.4,3,3s-1.4,3-3,3ZM861.2,282.4h-1c-1.7,0-3-1.4-3-3s1.3-3,3-3h1c1.6,0,3,1.4,3,3s-1.4,3-3,3ZM845.2,282.4h-1c-1.7,0-3-1.4-3-3s1.3-3,3-3h1c1.6,0,3,1.4,3,3s-1.4,3-3,3ZM829.2,282.4h-1c-1.7,0-3-1.4-3-3s1.3-3,3-3h1c1.6,0,3,1.4,3,3s-1.4,3-3,3ZM813.2,282.4h-1c-1.7,0-3-1.4-3-3s1.3-3,3-3h1c1.6,0,3,1.4,3,3s-1.4,3-3,3Z"
            />
            <path
              className="cls-2"
              d="M852,136.1c0,4.2-3.4,7.8-7.8,7.8s-7.8-3.4-7.8-7.8,3.4-7.8,7.8-7.8,7.8,3.4,7.8,7.8Z"
            />
          </g>
          <g className="cls-56">
            <g className="cls-56">
              <text className="cls-55" transform="translate(641.2 106)">
                <tspan x={0} y={0}>
                  {"Sports and platform expansion"}
                </tspan>
              </text>
            </g>
          </g>
          <g className="cls-56">
            <g className="cls-56">
              <text className="cls-55" transform="translate(713.5 163.6)">
                <tspan x={0} y={0}>
                  {"2025 Q2"}
                </tspan>
              </text>
            </g>
          </g>
          <g>
            <g className="cls-56">
              <g className="cls-56">
                <text className="cls-55" transform="translate(925.2 546.8)">
                  <tspan x={0} y={0}>
                    {"Sports expansion and Big events"}
                  </tspan>
                </text>
              </g>
            </g>
            <g className="cls-56">
              <g className="cls-56">
                <text className="cls-55" transform="translate(1003.3 496.4)">
                  <tspan x={0} y={0}>
                    {"2025 Q3"}
                  </tspan>
                </text>
              </g>
            </g>
            <g className="cls-56">
              <g className="cls-56">
                <text className="cls-57" transform="translate(1155.6 445.3)">
                  <tspan x={0} y={0}>
                    {"1. NFL, Ice Hockey, F1 and other sports"}
                  </tspan>
                </text>
              </g>
              <g className="cls-56">
                <text className="cls-57" transform="translate(1155.6 466.3)">
                  <tspan x={0} y={0} xmlSpace="preserve">
                    {"   will be live"}
                  </tspan>
                </text>
              </g>
              <g className="cls-56">
                <text className="cls-57" transform="translate(1155.6 487.3)">
                  <tspan x={0} y={0}>
                    {"2. VIP ?????????? (In lottery)"}
                  </tspan>
                </text>
              </g>
              <g className="cls-56">
                <text className="cls-57" transform="translate(1155.6 508.3)">
                  <tspan x={0} y={0}>
                    {"3. Thumba Coin? ("}
                  </tspan>
                </text>
              </g>
              <g className="cls-56">
                <text className="cls-58" transform="translate(1273.1 508.3)">
                  <tspan x={0} y={0}>
                    {"\u2026"}
                  </tspan>
                </text>
              </g>
              <g className="cls-56">
                <text className="cls-57" transform="translate(1291.1 508.3)">
                  <tspan x={0} y={0}>
                    {")"}
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g className="cls-56">
            <g className="cls-56">
              <text className="cls-57" transform="translate(225.2 141.9)">
                <tspan x={0} y={0}>
                  {"1. Launch Daily Fantasy sports app on bot."}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(225.2 162.9)">
                <tspan x={0} y={0}>
                  {"2. Big Five European Leagues in soccer will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(225.2 183.9)">
                <tspan x={0} y={0}>
                  {"3. ????????????? (For few users)"}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(225.2 204.9)">
                <tspan x={0} y={0}>
                  {"4. Rank frame will be live"}
                </tspan>
              </text>
            </g>
          </g>
          <g className="cls-56">
            <g className="cls-56">
              <text className="cls-57" transform="translate(506.7 444.6)">
                <tspan x={0} y={0}>
                  {"1. NBA and other sports will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(506.7 465.6)">
                <tspan x={0} y={0}>
                  {"2. Book maker model will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(506.7 486.6)">
                <tspan x={0} y={0}>
                  {"3. TMA will be launched"}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(506.7 507.6)">
                <tspan x={0} y={0}>
                  {"4. ???????? (VIP)"}
                </tspan>
              </text>
            </g>
          </g>
          <g className="cls-56">
            <g className="cls-56">
              <text className="cls-57" transform="translate(861.9 143.9)">
                <tspan x={0} y={0}>
                  {"1. MLB, Cricket and other sports will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(861.9 164.9)">
                <tspan x={0} y={0}>
                  {"2. IOS and Android app will be launched"}
                </tspan>
              </text>
            </g>
            <g className="cls-56">
              <text className="cls-57" transform="translate(861.9 185.9)">
                <tspan x={0} y={0}>
                  {"3. ????????????? (Online or Offline)"}
                </tspan>
              </text>
            </g>
          </g>
          <g className="cls-61">
            <g>
              <path
                className="cls-3"
                d="M484.5,303.5c.3-.5.3-1.4.2-2.2h0c-.5-.1-1-.1-1.4-.1-1.9,0-3.7.3-5.3,1,1.2.6,3,1.5,5,3,.7-.6,1.2-1.2,1.5-1.5v-.2h0Z"
              />
              <path
                className="cls-20"
                d="M492.1,312.1c-.7,0-1.4.2-1.9.4,2.5,4.5,3.5,10.1,3.8,14.2,2.5-2.6,4.1-6.1,4.3-9.9-1.7-2.1-4-4.9-6.2-4.6h0Z"
              />
              <path
                className="cls-30"
                d="M476.9,308.2c1.8-.4,3.5-1.3,4.8-2.2-2.8-1.9-5.1-2.9-5.6-3.1-2.9,1.6-5.2,4.1-6.6,7.1,1.8-.7,3.7-1.1,5.5-1.4.6-.1,1.2-.2,1.8-.4h.1Z"
              />
              <path
                className="cls-12"
                d="M487.3,308.7l.5.5c.6.6,1.1,1.3,1.6,2,.7-.3,1.5-.5,2.5-.6,2.4-.3,4.4,1.6,6.2,3.7-.4-3.1-1.7-5.9-3.7-8.1-1.1.1-2.3.3-3.5.7-.8.2-2.1.9-3.6,1.9h0Z"
              />
              <path
                className="cls-24"
                d="M485.3,316.4c.6-2.1,1.3-3.6,2.7-4.6-.4-.6-.9-1.2-1.3-1.7l-.7-.7c-5.5,3.8-13.1,10.7-13.8,16.7,2.3,2.5,5.5,4.2,9,4.7,1.3-2.6,2.5-7.8,3.2-10.9.3-1.5.6-2.8.9-3.6h0Z"
              />
              <path
                className="cls-4"
                d="M479,313.1c1.9-1.8,4-3.4,5.8-4.7-.6-.5-1.2-1-1.9-1.5-1.5,1.2-3.6,2.3-5.8,2.8-.6.1-1.3.2-1.9.4-2.4.4-4.6.9-6.5,1.9-.4,1.3-.6,2.7-.6,4.1,0,3.2,1,6.1,2.7,8.6,1.1-4.3,4.9-8.6,8.1-11.6h0Z"
              />
              <path
                className="cls-46"
                d="M486.2,307.6c1.8-1.1,3.3-1.9,4.3-2.2.9-.3,1.8-.5,2.6-.6-1.9-1.7-4.3-2.9-6.9-3.4,0,1,0,2.2-.5,3-.3.4-.8.9-1.5,1.5.6.5,1.3,1.1,2,1.7Z"
              />
              <path
                className="cls-5"
                d="M486.8,316.8c-.2.8-.5,2.1-.9,3.5-1,4.3-2,8.2-3.1,10.7h.5c3.5,0,6.7-1.2,9.3-3.2-.1-4.3-1.1-10.3-3.7-14.8-1,.7-1.5,1.9-2.1,3.7h0Z"
              />
            </g>
          </g>
          <g className="cls-59">
            <path
              className="cls-29"
              d="M821.2,327.1l1.5-1.5.8.8-1.5,1.5-.8-.8ZM819.6,325.6l1.5-1.5.8.8-1.5,1.5-.8-.8ZM818.1,324.1l1.5-1.5.8.8-1.5,1.5-.8-.8ZM816.6,322.5l1.5-1.5.8.8-1.5,1.5-.8-.8ZM824.2,327.1l.8.8-1.5,1.5-.8-.8,1.5-1.5ZM821.5,302.4c.9-.9,2.3-1.2,3.5-.7s2,1.7,2,3-.3,1.7-.9,2.3l-8,8c-.5.4-.9.9-1.5,1.2l-8.3,5.7-1.7-1.7,1.8-2.7,2.9-4.3h.6c.2,0,0,0,0,0h0c3.4,0,6.1-2.8,6.2-6.2h0v-1.4l3.2-3.2h.2ZM806.7,323.3l-1.5-1.5.8-.8,1.5,1.5-.8.8ZM805.2,324.8l-1.5-1.5.8-.8,1.5,1.5-.8.8ZM803.6,326.3l-1.5-1.5.8-.8,1.5,1.5-.8.8ZM802.1,327.9l-1.5-1.5.8-.8,1.5,1.5-.8.8ZM813,311.1c.3.1.6,0,.7-.3,0-.3,0-.6-.2-.7,0-.2.3-.5.5-.7.2.2.5.2.7,0s.2-.5,0-.7c.2-.2.4-.3.7-.4,0,.2.4.3.7.2s.4-.4.3-.7c.3-.1.7-.2,1-.2-.3,2.3-2.2,4.2-4.5,4.5,0-.3,0-.7.2-1h-.1ZM817.4,306.5c-.5,0-1,.2-1.5.4h0c0-.2-.2-.3-.4-.3s-.4,0-.5.2,0,.4,0,.5h0c-.3.2-.7.4-1,.7h0c-.2-.2-.5-.2-.8,0-.2.2-.2.5,0,.8h0c-.3.3-.5.6-.7,1h0c-.3-.1-.6,0-.7.2,0,.3,0,.6.3.7h0c-.2.5-.3,1-.4,1.5-2.7-.2-4.9-2.3-5-5,.5,0,1-.2,1.5-.4h0c0,.3.4.4.7.3s.4-.4.3-.7h0c.3-.2.7-.4,1-.7h0c.2.2.5.2.8,0,.2-.2.2-.5,0-.8h0c.3-.3.5-.6.7-1h.5c.2-.1.2-.3.2-.5s0-.4-.3-.4h0c.2-.5.3-1,.4-1.5,2.7.2,4.9,2.3,5,5h0ZM808.2,303c.8-.8,1.9-1.3,3-1.5,0,.3,0,.7-.2,1-.3-.1-.6,0-.7.3,0,.2,0,.6.2.7,0,.2-.3.4-.5.7-.2-.2-.5-.2-.7,0s-.2.5,0,.7c-.2.2-.4.3-.7.5,0-.2-.4-.3-.7-.2s-.4.4-.3.7c-.3.1-.7.2-1,.2.2-1.1.7-2.2,1.5-3h.1ZM807.5,316.2c-.5-.4-1-.8-1.5-1.2l-8-8c-.6-.6-.9-1.4-.9-2.3s.3-1.7.9-2.3c.6-.6,1.4-1,2.3-1s1.7.3,2.3,1l3.2,3.2v1h0c0,2.9,1.8,5.5,4.6,6.3l-2.4,3.5-.4-.3h0ZM799.8,327.1l1.5,1.5-.8.8-1.5-1.5.8-.8ZM800.2,331.3c-.2.2-.5.2-.8,0l-2.3-2.3c-.2-.2-.2-.6,0-.8s.5-.2.8,0h0l2.3,2.3c0,.1.2.2.2.4s0,.3-.2.4h0ZM815.9,317.9l1.5,2.2-1.7,1.7-2.8-1.9,2.9-2h0ZM826.9,329l-2.3,2.3c-.2.2-.5.2-.8,0-.2-.2-.2-.5,0-.8h0l2.3-2.3h0s.2-.2.4-.2.3,0,.4.2c.2.2.2.5,0,.8h0Z"
            />
          </g>
          <g className="cls-64">
            <g>
              <path className="cls-9" d="M870.6,304.7h2.1v2.3h-2.1v-2.3Z" />
              <path
                className="cls-25"
                d="M872.7,302.5c0-.3,0-.6-.3-.8s-.5-.3-.7-.3-.5.1-.7.3-.3.5-.3.8v1.3h2.1v-1.3h0Z"
              />
              <path className="cls-21" d="M872.7,309.9v-1.9h-2.1v1.9l1.1,4.7,1.1-4.7h0Z" />
              <path
                className="cls-44"
                d="M880.1,307.1h-.9c-.2,0-.5.1-.7.3s-.3.4-.3.7v19.3c0,1.1.4,2.1,1,3h.2c.2.2,0,.1.2.1h.4c.7-.9,1-2,1-3.1v-19.3c0-.2,0-.5-.3-.7-.2-.2-.4-.3-.7-.3h0Z"
              />
              <path
                className="cls-22"
                d="M886.2,307.1h-.9c-.2,0-.5.1-.7.3s-.3.4-.3.7v19.3c0,1.1.4,2.1,1,3h.2c0,.1.4.1.4.1h.2c.7-.9,1-2,1-3.1v-19.3c0-.2,0-.5-.3-.7-.2-.2-.4-.3-.7-.3h0Z"
              />
              <path
                className="cls-45"
                d="M892.3,307.1h-.9c-.2,0-.5.1-.7.3s-.3.4-.3.7v19.3c0,1.1.4,2.1,1,3h.2c0,.1.4.1.4.1,0,0,.1,0,.2-.1.7-.8,1-1.9,1-3v-19.3c0-.2,0-.5-.3-.7-.2-.2-.4-.3-.7-.3h0Z"
              />
              <path
                className="cls-37"
                d="M891.3,303.3h-4.2c-.5,0-.9.4-.9.9v.9c0,.5.4.9.9.9h4.2c.5,0,.9-.4.9-.9v-.9c0-.5-.4-.9-.9-.9Z"
              />
              <path
                className="cls-51"
                d="M884.3,303.3h-4.2c-.5,0-.9.4-.9.9v.9c0,.5.4.9.9.9h4.2c.5,0,.9-.4.9-.9v-.9c0-.5-.4-.9-.9-.9Z"
              />
              <path
                className="cls-49"
                d="M870.2,326.1l-.6.6h-.8v-.8l.6-.6c-.5-.4-1.2-.6-1.9-.5-.7,0-1.3.3-1.8.8s-.8,1.1-.8,1.8,0,1.3.5,1.9l.6-.6s.2-.1.3-.1.2,0,.3.1v.6l-.6.6c.5.4,1.2.6,1.9.5.7,0,1.3-.3,1.8-.8s.8-1.1.8-1.8,0-1.3-.5-1.9l.2.2h0ZM868.6,327.7l-.7.7s-.2.1-.3.1-.2,0-.3-.1v-.6l.7-.7h.2q0-.1.2-.1h.4v.6h0c0,.1-.2.1-.2.1h0Z"
              />
              <path
                className="cls-47"
                d="M874.1,310.7l-.5-.3h0l-1.4,6.4c0,.1,0,.2-.2.3,0,0-.2.1-.3.1s-.2,0-.3-.1c0,0,0-.1-.2-.3l-1.4-6.4h0l-.5.3c-.3.2-.5.4-.6.7-.2.3-.2.6-.2.9v11.7c.7,0,1.4.4,1.9.8.6.5,1,1.1,1.2,1.8s.2,1.4,0,2.1-.6,1.3-1.1,1.8h3.6c.2,0,.5,0,.7-.3.2-.2.3-.4.3-.7v-17.2c0-.3,0-.6-.2-.9s-.4-.5-.6-.7h-.2Z"
              />
            </g>
          </g>
        </g>
        <path
          className="cls-2"
          d="M484,501.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,485.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,469.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,453.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,437.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,421.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,405.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,389.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,373.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3ZM484,357.3c-1.7,0-3-1.3-3-3v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0,1.7-1.4,3-3,3Z"
        />
        <path
          className="cls-2"
          d="M491.8,500.8c0,4.2-3.4,7.8-7.8,7.8s-7.8-3.4-7.8-7.8,3.4-7.8,7.8-7.8,7.8,3.4,7.8,7.8Z"
        />
        <path
          className="cls-2"
          d="M1135.8,507.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,491.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,475.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,459.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,443.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,427.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,411.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,395.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,379.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,363.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3ZM1135.8,347.6c-1.7,0-3-1.3-3-3v-1c0-1.6,1.3-3,3-3s3,1.4,3,3v1c0,1.7-1.3,3-3,3Z"
        />
        <path
          className="cls-2"
          d="M1143.7,500.7c0,4.2-3.4,7.9-7.9,7.9s-7.9-3.4-7.9-7.9,3.4-7.9,7.9-7.9,7.9,3.4,7.9,7.9Z"
        />
        <g>
          <circle className="cls-38" cx={1135.9} cy={316.1} r={32.6} transform="translate(109.2 895.8) rotate(-45)" />
          <circle className="cls-38" cx={1202.9} cy={316} r={32.6} transform="translate(128.8 943.1) rotate(-45)" />
          <circle className="cls-38" cx={1068.8} cy={316} r={32.6} transform="translate(89.6 848.3) rotate(-45)" />
          <path
            className="cls-2"
            d="M1200.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1184.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1168.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1152.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1136.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1120.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1104.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1088.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3ZM1072.8,362.6h-1c-1.7,0-3-1.3-3-3s1.3-3,3-3h1c1.7,0,3,1.4,3,3s-1.3,3-3,3Z"
          />
        </g>
        <g className="cls-62">
          <g>
            <path
              className="cls-16"
              d="M1081.9,329c-1.2,0-2.3-.3-3.3-.9v1.1c0,.9,1.5,1.7,3.3,1.7s3.3-.7,3.3-1.7v-1.1c-1,.6-2.1.9-3.3.9Z"
            />
            <path
              className="cls-28"
              d="M1081.9,328c1.8,0,3.3-.7,3.3-1.6s-1.5-1.6-3.3-1.6-3.3.7-3.3,1.6,1.5,1.6,3.3,1.6Z"
            />
            <path className="cls-6" d="M1083.3,301.8l-6.7,12.3h0l2.6,1.6,6-11.1v-2.8h-1.9Z" />
            <path
              className="cls-17"
              d="M1061.1,324.3c-.6,0-1.2.2-1.7.6s-.8.9-1,1.5l-.3.9v1.4c0,.6.5,1.2,1,1.6s1.1.6,1.8.6h1l1.9-6.6h-2.7Z"
            />
            <path
              className="cls-26"
              d="M1072.7,321.3l-.8,1.4c-.2.5-.6.9-1,1.1-.4.3-1,.4-1.5.4h-2.5l-1.9,6.6h4.4c.5,0,1-.2,1.5-.4.4-.3.8-.7,1-1.1l3.4-6.4h0l-2.6-1.6Z"
            />
            <path className="cls-39" d="M1076.2,314.9l-3,5.6h0l2.6,1.6,3-5.6h0l-2.6-1.6Z" />
            <path className="cls-54" d="M1064.6,318.6v-.5h-3.3v.4l.9,2.3v.2h3.2l-.9-2.2v-.2h.1Z" />
            <path className="cls-1" d="M1061.3,314.4h3.3v2.8h-3.3v-2.8Z" />
            <path className="cls-34" d="M1064.6,312.1v-.2l.7-2.2h-3.2l-.8,2.4v1.3h3.3v-1.4h0Z" />
            <path className="cls-19" d="M1060.4,318.6v-.5h-3.3v.5l1.4,2.3h2.8l-.9-2.2v-.2h0Z" />
            <path className="cls-18" d="M1060.4,312.1v-.2l.7-2.2h-3.6v.3c-.3.8-.4,1.7-.4,2.5v.9h3.3v-1.4h0Z" />
            <path className="cls-11" d="M1057.1,314.4h3.3v2.8h-3.3v-2.8Z" />
            <path className="cls-23" d="M1068.8,316.9l-3.3,1.1v.5l.9,2.3v.2h1.4l.9-1.6v-2.5h0Z" />
            <path className="cls-48" d="M1065.5,312.2v1.2l3.3-1.1v-2.5h-2.5l-.8,2.4h0Z" />
            <path
              className="cls-32"
              d="M1070.3,303.3c-2.4-.9-5-.8-7.3.2s-4.2,2.9-5.1,5.2h11.4s.2,0,.3.1v9l5.2-7.3v-4c-1.1-1.6-2.8-2.8-4.6-3.4v.2h0ZM1069.8,306.9h-.5s-.2,0-.3-.1v-.6s.2-.1.3-.1h.5s.2,0,.3.1v.6s-.2.1-.3.1ZM1070.7,306.5v-.3s.2-.1.3-.1h.5s.2,0,.3.1v.6s-.2.1-.3.1h-.5s-.2,0-.3-.1v-.3Z"
            />
            <path className="cls-50" d="M1065.5,317.1l3.3-1.1v-2.8l-3.3,1.1v2.8Z" />
          </g>
        </g>
        <g className="cls-65">
          <path
            className="cls-43"
            d="M1206,314.9h-3.5v-4.3h.6c1,0,1.9.5,2.5,1.2h-1.2c-.3,0-.6.3-.6.6v.6c0,.3.3.6.6.6h1.9c0,.4,0,.9-.3,1.2h0ZM1195,315.5c.6,0,1.3.1,1.8.3l-1.8-5.5c0-.2-.3-.4-.6-.4h-3.8c-.3,0-.6.3-.6.6v7.5c0,.3.2.5.4.6.8-1.8,2.5-3.1,4.6-3.1h0ZM1219.4,319.3h-2c0,.4.2.8.2,1.2,0,.7,0,1.3-.4,1.9h2.2c.3,0,.6-.3.6-.6v-1.9c0-.3-.3-.6-.6-.6h0ZM1209.4,313c-.2,0-.4,0-.5.2l-2.4,2.9h-5.2v-5.6c0-.3-.3-.6-.6-.6-1.4,0-2.8.7-3.9,1.8l1.7,5.2c.9.9,1.5,2.2,1.5,3.6s0,1.3-.4,1.9h8.2c-.2-.6-.4-1.2-.4-1.9,0-2.8,2.2-5,5-5s3.5,1,4.3,2.5h2.4c-1.8-2.2-5.2-5-9.9-5h.2ZM1216.3,320.5c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8,1.7-3.8,3.8-3.8,3.8,1.7,3.8,3.8ZM1213.8,320.5c0-.7-.6-1.2-1.2-1.2s-1.2.6-1.2,1.2.6,1.2,1.2,1.2,1.2-.6,1.2-1.2ZM1198.8,320.5c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8,1.7-3.8,3.8-3.8,3.8,1.7,3.8,3.8ZM1196.3,320.5c0-.7-.6-1.2-1.2-1.2s-1.2.6-1.2,1.2.6,1.2,1.2,1.2,1.2-.6,1.2-1.2Z"
          />
        </g>
        <g>
          <path
            className="cls-40"
            d="M1131.5,328.8c-3.8.6-6.9,0-7.8-.9-.8-.8-1.5-3.9-.9-7.8,2.4,3.5,5.3,6.4,8.7,8.7h0Z"
          />
          <path className="cls-41" d="M1139.9,302.9c3.8-.6,7,0,7.8.9.8.8,1.5,3.9.9,7.8-2.3-3.3-5.2-6.2-8.7-8.7h0Z" />
          <path
            className="cls-27"
            d="M1137.4,303.5c-2.9.8-6.1,2.4-8.8,5.2-2.8,2.8-4.3,5.9-5.2,8.8,2.9,4.5,6.5,8.1,10.7,10.7,3-.8,6.1-2.4,8.9-5.2,2.8-2.8,4.3-5.9,5.2-8.9-2.6-4.2-6.2-7.8-10.7-10.7h0ZM1138.1,309.4c-.3.2-.7.4-1,.7l.7.7c.3.3.3.7,0,1s-.7.3-1,0l-.9-.9c-.5.4-1,.8-1.5,1.2l1,1c.3.3.3.7,0,1s-.7.3-1,0l-1-1c-.2.2-.3.2-1.3,1.3l1,1c.3.3.3.7,0,1s-.7.3-1,0l-.9-.9c-.4.5-.8,1-1.1,1.5l.7.7c.3.3.3.7,0,1s-.7.3-1,0l-.5-.5c-.2.3-.4.7-.6,1s-.6.5-.9.3-.5-.6-.3-1c.3-.5.5-1,.8-1.4l-.8-.8c-.3-.3-.3-.7,0-1s.7-.3,1,0l.6.6c.4-.5.7-1,1.1-1.5l-.4-.4c-.3-.3-.3-.7,0-1s.7-.3,1,0l.3.3c1-1.2,1.1-1.1,1.3-1.3l-.3-.3c-.3-.3-.3-.7,0-1s.7-.3,1,0l.3.3c.5-.4,1-.8,1.5-1.2l-.4-.4c-.3-.3-.3-.7,0-1s.7-.3,1,0l.6.6c.4-.3.9-.6,1.3-.8.3-.2.8,0,1,.2.2.3,0,.8-.2,1h0Z"
          />
        </g>
      </g>
    </svg>
  </div>
);
